import React from "react";
import "./VirasatV2ComingSoonPage.scss"
import bg from "../../assets/bg.jpg"
import SubscriptionComponent from "../../components/SubscriptionComponent/SubscriptionComponent";
import { sortByOrderAscending } from "../../helper/helper";
import { useSelector } from "react-redux";
const VirasatV2ComingSoonPage = () => {
    const pages = useSelector((state) => state.companyData.pages)
    const page = pages.find((page) => page.PageId === "comingsoon")

    const Components = page?.Components || []
    const getHeaderComponents = (component) => {
        switch (component.ID) {
            case "VirasatComingSoonPage-hero-header":
                return <div className="VirasatV2ComingSoonPage-hero-header-cont">
                    <div className="VirasatV2ComingSoonPage-hero-header">{component?.Props?.header}</div>
                    <div className="VirasatV2ComingSoonPage-hero-subheader">{component?.Props?.subheader}</div>
                </div>
            default:
                return <div />
        }

    }
    const headerComponent = (headerComponents) => {
        return (
            <div className="VirasatV2ComingSoonPage-container"
                style={{
                    backgroundImage: `linear-gradient(0deg, rgba(22, 65, 106, 0.4), rgba(22, 65, 106, 0.4)),
                    linear-gradient(0deg, rgba(22, 65, 106, 0.2), rgba(22, 65, 106, 0.2)),
                    linear-gradient(0deg, rgba(22, 65, 106, 0.2), rgba(22, 65, 106, 0.2)), url(${bg})`
                }}>
                <div className="VirasatV2ComingSoonPage-container-wrapper">
                    {sortByOrderAscending(headerComponents?.Components).map((component, key) => {
                        return (
                            getHeaderComponents(component)
                        )
                    })}
                </div>
            </div>
        )
    }
    const getComponents = (component) => {
        switch (component.ID) {
            case "VirasatComingSoonPage-hero":
                return headerComponent(component)
            case "VirasatComingSoonPage-subcription":
                return <SubscriptionComponent />
            default:
                return <div />
        }

    }
    return (
        <div className="VirasatV2ComingSoonPage" >

            {sortByOrderAscending(Components).map((component, key) => {
                return (getComponents(component))
            })}

        </div>

    )
}
export default VirasatV2ComingSoonPage